import(/* webpackMode: "eager", webpackExports: ["AppShell"] */ "/vercel/path0/apps/premiere-plugin/src/app/_components/AppShell.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/premiere-plugin/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/primitive/emoji-picker/src/EmojiPicker.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/component/emoji-menu/src/EmojiMenu.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"display\":\"swap\",\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/utils/utils-tailwind/src/variants.ts");
